 <form [formGroup]="form" class="date-form text-center">

    <!-- RANGO DE FECHAS -->
    <div class="date-row">

      <!-- Modo selector: datehour / onlydate -->
      <mat-form-field appearance="outline" class="full-width"
        *ngIf="modeSelect === 'datehour' || modeSelect === 'onlydate'">
        <mat-label>{{'datetimerange.rangeDate'|traduccion}}</mat-label>
        <mat-date-range-input [rangePicker]="pickerRange"
                              [formGroup]="form"
                              [min]="minAsDate"
                              [max]="maxAsDate">
          <input matStartDate formControlName="fromDate" placeholder="Desde">
          <input matEndDate formControlName="toDate" placeholder="Hasta">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="pickerRange"></mat-datepicker-toggle>
        <mat-date-range-picker #pickerRange></mat-date-range-picker>
        <app-form-error [control]="form.get('fromDate')" ></app-form-error>
        <app-form-error [control]="form.get('toDate')" ></app-form-error>
      </mat-form-field>

      <!-- Modo botones -->
      <div *ngIf="modeSelect === 'datebutton'" class="inline-fields">
        <button mat-icon-button color="primary" (click)="less()" [disabled]="getDiffDays() <= 1">
          <mat-icon>remove</mat-icon>
        </button>

        <div class="fixed-range">
          <span>{{ formatDate(form.value.fromDate) }}</span>
          <mat-icon>arrow_forward</mat-icon>
          <span>{{ formatDate(form.value.toDate) }}</span>
        </div>

        <button mat-icon-button color="primary" (click)="plus()" [disabled]="getDiffDays() >= MAX_DAYS_FUTURE">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>

    <!-- HORAS -->
    <div class="time-row" *ngIf="modeSelect === 'datehour'">
      <mat-form-field appearance="outline">
        <mat-label>{{'datetimerange.time.start'|traduccion}}</mat-label>
        <mat-select formControlName="fromTime">
          <mat-option *ngFor="let t of fromTimeOptions" [value]="t">{{ t }}</mat-option>
        </mat-select>
        <app-form-error [control]="form.get('fromTime')" ></app-form-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{'datetimerange.time.end'|traduccion}}</mat-label>
        <mat-select formControlName="toTime">
          <mat-option *ngFor="let t of toTimeOptions" [value]="t">{{ t }}</mat-option>
        </mat-select>
        <app-form-error [control]="form.get('toTime')" ></app-form-error>
      </mat-form-field>
    </div>

    <!-- RESUMEN -->
    <div *ngIf="showDetail" class="summary">
      <h3>{{ getDuration() }}</h3>
      <h5>Desde: <span>{{ getFromDateTimeSrt() }}</span></h5>
      <h5>Hasta: <span>{{ getToDateTimeSrt() }}</span></h5>
      <h5>Total: <span class="price">{{ minPrice }}€</span></h5>
    </div>

  </form>